import resources from "../../core/Localization/Localization";
import { correctionOptions, currencyTypes, refundedOptions, tokenCorrectionTypes, TransactionTypes } from "../transactions/config";
import { getDateString } from "../../utils/getDateString";

export const transactionColumns = (type) => {
    let columns = [
        {
            field: "id",
            headerName: resources.finance.datagrid.transactionId,
            filter: true,
            sort: true,
            filterType: "textField",
            flex: 1,
        },
        {
            field: "username",
            headerName: resources.finance.datagrid.user,
            filter: true,
            sort: true,
            filterType: "textField",
            flex: 1
        },
        {
            field: "amount",
            headerName: resources.finance.datagrid.amount,
            filter: true,
            sort: true,
            filterType: "textField",
            flex: 1
        },
        {
            field: "currency_amount",
            headerName: resources.finance.datagrid.currencyAmount,
            filter: true,
            sort: true,
            filterType: "textField",
            flex: 1
        },
        {
            field: "currency",
            headerName: resources.finance.datagrid.currency,
            filter: true,
            sort: true,
            filterType: "dropdown",
            filterOptions: {
                names: Object.values(currencyTypes),
                renderValue: (v) => v.toUpperCase(),
            },
            flex: 1
        },
    ];

    switch (type) {
        case TransactionTypes.PAYIN:
            columns = columns.concat([]);
            break;
        case TransactionTypes.CORRECTION:
            columns = columns.concat([
                {
                    field: "correction_type",
                    headerName: resources.finance.datagrid.correctionType,
                    filter: true,
                    sort: true,
                    filterType: "dropdown",
                    filterOptions: {
                        names: Object.values(tokenCorrectionTypes),
                        renderValue: (v) => correctionOptions().find((x) => x.value === v).headerName,
                    },
                    customFilterListOptions: {
                        render: (v) => `${resources.finance.datagrid.correctionType}: ${correctionOptions().find((x) => x.value === v).headerName}`,
                    },
                    flex: 1
                },
            ]);
            break;

        default:
            columns = columns.concat([
                {
                    field: "part_offer_id",
                    headerName: resources.finance.datagrid.partOfferId,
                    filter: true,
                    sort: true,
                    filterType: "textField",
                    flex: 1
                },
                {
                    field: "refunded",
                    headerName: resources.finance.datagrid.refunded,
                    filter: true,
                    sort: true,
                    filterType: "dropdown",
                    filterOptions: {
                        names: [0, 1],
                        renderValue: (v) => refundedOptions().find((x) => x.value === v).headerName,
                    },
                    customFilterListOptions: {
                        render: (v) => `${resources.finance.datagrid.refunded}: ${refundedOptions().find((x) => x.value === v).headerName}`,
                    },
                    flex: 1
                },
                {
                    field: "refunded_amount",
                    headerName: resources.finance.datagrid.refundedAmount,
                    filter: true,
                    sort: true,
                    filterType: "textField",
                    flex: 1
                },
            ]);
            break;
    }
    columns.push({
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    });

    return columns;
};
